import { Image, type ImageProps } from "@/components/ui/image";
import logoBlack from "@/public/images/brand/basemaker.svg";
import logoWhite from "@/public/images/brand/basemaker-white.svg";

interface BasemakerLogoProps extends Omit<ImageProps, "src" | "alt"> {
	theme?: "light" | "dark";
}

export function BasemakerLogo({
	theme = "light",
	...props
}: Readonly<BasemakerLogoProps>) {
	const logoImage = theme === "light" ? logoBlack : logoWhite;

	return <Image src={logoImage} alt="Basemaker" priority {...props} />;
}
